export enum AppCodeError {
    LOGOUT_PROPERLY = "ECARPA0000", // Le client s'est authentifié sans erreur et a déconnecté normalement
    AUTH_ERROR = "ECARPA0001", // Erreur authentification
    UNKNOWN_USER = "ECARPA0002", // L'utilisateur est inconnu dans le système
    UNAUTHORIZED_ACCESS = "ECARPA0003", // Accès non autorisé
    REFRESH_TOKEN_ERROR = "ECARPA0008", // Erreur lié au refresh token
    API_LOGIN_FAILED = "ECARPA0010", // Erreur lié au Api FO
    
    INVALID_CNBF = "ECARPA0050", // Cnbf est invalide ou null (souvent c'est avocle qui n'envoie pas le cnbf)
    NO_ACTIVE_CURRENT_COMPTE_FOUND = "ECARPA0051", // Aucun compte actif de l'avocat courant n'a été trouvé
    NO_VALID_CARPA_COMPTE_ASSOCIATED = "ECARPA0052", // Aucune Carpa valide associé à votre compte utilisateur n'a pu être chargée

    HTTP_ERROR_401 = "ECARPA0100",
}
  